import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"];

  submitOnChange() {
    this.formTarget.submit();
  }
}
